var map = {
	"./css.png": "3c05",
	"./gimp.png": "36e0",
	"./html.png": "c99e",
	"./js.png": "f9f8",
	"./originals/css.png": "692f",
	"./originals/gimp.png": "e339",
	"./originals/html.png": "cfee",
	"./originals/js.png": "c962",
	"./originals/pinia.png": "032a",
	"./originals/scratch.png": "96d4",
	"./originals/vue.png": "2641",
	"./pinia.png": "1840",
	"./scratch.png": "b5cc",
	"./vsc.png": "83cc",
	"./vue.png": "8bc0"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "777d";